import { useTexts } from '@/feature/lang';
import { track } from '@/feature/tracking';
import { Icon } from '@/icon/Icon';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import { differenceInDays } from 'date-fns';
import { useRef } from 'react';
import TimePeriod from '../Date/TimePeriod';
import Tooltip from '../Tooltip';
import NoWrap from '../Typography/NoWrap';
import { useDateRange } from './DateRangeProvider';
import { useDateRangeState } from './DateRangeStateProvider';
import { getActivePreset } from './presets';
import { steppers } from './steppers';

const Trigger = (props: PopperTriggerProps) => {
  const { initialValue, iconButton } = useDateRange();
  const activePreset = getActivePreset(initialValue);
  const ref = useRef(null);

  return (
    <ButtonGroup sx={{ maxWidth: '100%' }} color="inherit" variant="outlined">
      {iconButton ? (
        <Button onClick={props.onClick} size="large" ref={ref}>
          <Icon name="calendar" size="small" />
        </Button>
      ) : (
        <Button
          ref={ref}
          startIcon={<Icon name="calendar" size="small" />}
          onClick={props.onClick}
        >
          <NoWrap>
            {activePreset?.label ?? getTriggerLabel(initialValue)}
          </NoWrap>
        </Button>
      )}
      <UndoStateAction />
    </ButtonGroup>
  );
};
export default Trigger;

const UndoStateAction = () => {
  const dateRangeState = useDateRangeState();
  const texts = useTexts().component.dateRange.actions.undoState;

  if (!dateRangeState) {
    return null;
  }

  return (
    <Tooltip title={dateRangeState.enableUndo ? texts.tooltip : undefined}>
      <Button
        onClick={() => {
          dateRangeState.undo();
          track('daterange_undo');
        }}
        size="small"
        color="inherit"
        disabled={!dateRangeState.enableUndo}
      >
        <Icon name="undo" size="small" />
      </Button>
    </Tooltip>
  );
};

function getTriggerLabel(range: string[]) {
  const from = new Date(range[0]);
  const to = new Date(range[1]);

  if (steppers.day.isActive(from, to) && differenceInDays(to, from) > 1) {
    return (
      <TimePeriod from={from} to={to} showDates="always" showTimes="never" />
    );
  }
  return <TimePeriod from={from} to={to} showDates="different" />;
}
